import React from 'react';
import { useParams } from 'react-router-dom';
import { getAnalyticsStudents } from '../../services/teacherApi';
import { StudentCards } from '../../components/teacherAnalytics/StudentCards';
import {
  AnalyticsGate, CourseShell, FractionView, LoadState, MeasureView, Pager,
  Panel, RestoreFocus, Search, useAnalytics, useQueryState
} from '../../components/teacherAnalytics/AnalyticsShared';

function Roster() {
  const {courseId = ''} = useParams();
  const {params, update, pageNumber} = useQueryState();
  const page = pageNumber();
  const q = params.get('q') || '';
  const resource = useAnalytics(`${courseId}/students/${page}/${q}`,
    signal => getAnalyticsStudents(courseId, {page, limit: 20, q}, signal));
  const course = resource.result?.data.course;
  return <CourseShell course={course}><Panel>
    <h2 data-results-heading tabIndex={-1}>学生列表</h2>
    {course && <p>在籍学生 {course.enrolledStudents} 人 · 当前知识元 {course.assignedTopics} 个 · 非空章节 {course.nonemptyChapters} 个</p>}
    <Search value={q} loading={resource.loading} onSearch={value => update({q: value || null, page: 1}, 'analytics-name-search')} />
    <LoadState resource={resource} label="正在加载学生列表…">{data => <>
      <RestoreFocus ready />
      {!data.students.items.length && <p>{page > 1 ? '当前页暂无记录。' : q ? '未找到匹配的学生。' : '暂无学生注册此课程。'}</p>}
      <StudentCards students={data.students.items} courseId={courseId} label="学生学习记录" showEnrollment
        summaryMetrics={s => [
          {label: '已完成章节', value: <FractionView value={s.chapters} unit="章" compact />},
          {label: '已完成知识元', value: <FractionView value={s.topics} unit="个" compact />}
        ]}
        metrics={s => [
          {label: '已记录完成章节', value: <FractionView value={s.chapters} unit="章" />},
          {label: '已记录完成知识元', value: <FractionView value={s.topics} unit="个" />},
          {label: '已记录练习次数', value: <MeasureView measure={s.attempts} unit=" 次" />},
          {label: '练习用时', value: <MeasureView measure={s.exerciseTimeSeconds} unit=" 秒" />}
        ]} />
      <Pager pagination={data.students.pagination} onPage={p => update({page: p})} />
    </>}</LoadState>
  </Panel></CourseShell>;
}
export const CourseStudentsPage = () => <AnalyticsGate><Roster /></AnalyticsGate>;
